import { LuDownload, LuX } from 'react-icons/lu'

import { FeatureFlag } from '@/feature/feature-flags'
import messageStyles from '@/feature/observatory/components/ObservatoryPage.module.css'
import { ReportModal } from '@/feature/reports/components/ReportModal'

import { ReplayMapMessageProps } from './ReplayMapMessage.types'
import { useReplayMapMessage } from './useReplayMapMessage'

import styles from './ReplayMapMessage.module.css'

export type { ReplayMapMessageProps }

export const ReplayMapMessage = ({
  assetId,
  onClose,
  selectionStart,
  selectionEnd,
}: ReplayMapMessageProps) => {
  const { reportOpen, setReportOpen, requestReport } = useReplayMapMessage(assetId)

  return (
    <>
      <FeatureFlag flag="featureReports">
        <ReportModal
          open={reportOpen}
          title={'Export Replay Events'}
          toDateLimit={new Date()}
          onClose={() => setReportOpen(false)}
          onRequest={requestReport}
          defaultDateRange={{ to: selectionEnd, from: selectionStart }}
          pickerProps={{
            max: 7,
          }}
        />
      </FeatureFlag>
      <div className={messageStyles.mapMessage} data-testid="replay-map-message">
        <div className={[messageStyles.replayMessageInfo, styles.messageWrapper].join(' ')}>
          <span className={messageStyles.mapMessageText}>
            Viewing <b>History</b>
          </span>
        </div>
        <div className={styles.buttonContainer}>
          <FeatureFlag flag="featureReports">
            <button
              type="button"
              className={styles.mapMessageButton}
              onClick={() => setReportOpen(!reportOpen)}
              data-testid="replay-download-button"
            >
              <LuDownload />
              Download
            </button>
          </FeatureFlag>
          <button
            type="button"
            className={messageStyles.mapMessageButton}
            onClick={onClose}
            data-testid="replay-end-button"
          >
            <LuX size="16" />
            <span>End Replay</span>
          </button>
        </div>
      </div>
    </>
  )
}
